import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { StandingDataRepository } from './standing-data.repository';

@NgModule({
  imports: [CommonModule],
  providers: [StandingDataRepository]
})
export class CommonStandingDataModule {}
